import { render } from "./knowledgebase-index.vue?vue&type=template&id=1f3c31d5"
import script from "./knowledgebase-index.vue?vue&type=script&lang=js"
export * from "./knowledgebase-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__